import { useContext, useRef, useState } from "react";
import { Badge, Button } from "flowbite-react";
import { ResponseContext } from "../../../context/responseProvider";
import { createMerchItem } from "../../../services/merchManager/merchManagerActions";
import MerchFrom from "./merchFrom";
import { useMerchForm } from "../../../hooks/useMerchForm";
import { Dialog } from "@headlessui/react";
import { useVerifiedUser } from "../../../hooks/useVerifiedUser";

const DEFAULT_FORM = {
  item_name: "",
  item_count: "",
  item_purpose: "",
  item_location: "",
  strorage_location: "",
  assets: [],
};

const REQUIRED = ["item_name", "item_count", "storage_location"];

const AddMerchForm = ({ modalRef, handleApi }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { getResponse, setResponse } = useContext(ResponseContext);
  const formRef = useRef(null);
  const response = getResponse("add_new_merch");
  const { isVerified } = useVerifiedUser(["merch_editor"]);

  const {
    form,
    previews,
    fieldErrors,
    disableBtn,
    fileInputRef,
    handleChange,
    handleFiles,
    removeFile,
    reset,
  } = useMerchForm(null, DEFAULT_FORM, REQUIRED);

  const handleClose = () => modalRef.current();

  const handleSubmit = (e) => {
    e.preventDefault();
    createMerchItem({
      isVerified,
      form,
      email: localStorage.getItem("userEmail"),
      setIsLoading,
      setResponse,
      formRef,
      onSuccess: () => {
        reset();
        handleApi();
        handleClose();
      },
    });
  };

  return (
    <div className="w-full max-h-[80vh] overflow-y-auto">
      <div className="flex h-full flex-col gap-4 p-6 pl-2">
        <Dialog.Title
          as="h3"
          className="text-lg font-medium leading-6 text-gray-900 inline-flex"
        >
          <strong className="flex align-middle">Add New Item</strong>
        </Dialog.Title>
        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="flex flex-col gap-6"
        >
          <MerchFrom
            form={form}
            handleChange={handleChange}
            fieldErrors={fieldErrors}
            previews={previews}
            fileInputRef={fileInputRef}
            handleFiles={handleFiles}
            removeFile={removeFile}
          />
          {/* ── API error ── */}
          {response?.status === false && (
            <Badge color="failure">{response?.message}</Badge>
          )}

          {/* ── Actions ── */}
          <div className="flex mt-2 items-center justify-between pt-2 border-t border-gray-100 dark:border-gray-700">
            <button
              type="button"
              className="text-sm font-semibold text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
              onClick={handleClose}
            >
              Cancel
            </button>
            <Button type="submit" disabled={disableBtn || isLoading}>
              {isLoading ? "Creating..." : "Create item"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddMerchForm;
